export default "__VITE_ASSET__39bbe9c1__"